<div id="placement" class="container mx-auto" data-cy="placement">
  <div [formGroup]="control" class="form">
    <ife-title
      [title]="'modules.evcQuote.steps.technicalDetails.steps.placement.title' | translate"
      data-cy="charging-station-placement-title"
    ></ife-title>

    <p class="text-center">
      {{ "modules.evcQuote.steps.technicalDetails.steps.placement.description" | translate }}
    </p>

    <div class="flex flex-col">
      <div class="flex flex-col sm:flex-row justify-center items-center sm:items-start my-16">
        <div class="md:mr-16">
          <!-- File picker -->
          <ife-image-picker
            class="w-full sm:w-max"
            [imageUrl]="control.get('value').value ? baseUrl + control.get('value').value : null"
            (selectImage)="processFile($event)"
          >
          </ife-image-picker>

          <!-- Delete image btn -->
          <button
            data-cy="remove-image"
            *ngIf="control.get('value').value"
            class="btn-secondary bottom-8 button-limits mx-auto w-full sm:w-auto block my-8"
            (click)="deleteFile()"
          >
            {{ "modules.evcQuote.general.deletePicture" | translate }}
          </button>
        </div>
        <!-- Example image -->
        <div
          class="example-image mobile-example-image mt-8 sm:mt-0"
          [ngClass]="{ responsive: control.get('value').value }"
          data-cy="example-image"
        >
          <img [src]="'./assets/evc/img/placement.png'" [alt]="" />
        </div>
      </div>
    </div>

    <!-- QR Code part -->
    <div *ngIf="!control.get('value').value && isDesktopDevice" class="flex flex-col max-w-max mx-auto">
      <div class="line"></div>
      <p class="text-center my-12">
        {{ "modules.evcQuote.general.qrcodeInfo" | translate }}
      </p>

      <div class="qr-section max-w-max mx-auto shadow-lg rounded-lg overflow-hidden">
        <qrcode
          data-cy="qrcode"
          [qrdata]="href"
          [width]="160"
          [errorCorrectionLevel]="'M'"
          [elementType]="'svg'"
        ></qrcode>
      </div>
    </div>

    <!-- Only show nex when image has been selected -->
    <ife-navigation
      [showNext]="control.get('value').value"
      [showContinueLater]="!control.get('value').value"
      [showPrevious]="true"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
      (continueLaterStep)="goToContinueLater()"
    >
    </ife-navigation>
  </div>
</div>
